import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, X, ArrowRight } from '../../icons/wp-icons';
import { getSubscription } from '../../api/stripeApi';

function TrialBanner() {
  const [subscription, setSubscription] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const data = await getSubscription();
        setSubscription(data);
      } catch (error) {
        console.error('Error fetching subscription for banner:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();

    // Refresh every 5 minutes
    const interval = setInterval(fetchSubscription, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Don't show if loading, dismissed, or not in trial
  if (loading || dismissed) return null;
  if (!subscription || subscription.planStatus !== 'TRIAL') return null;

  const daysRemaining = subscription.trialDaysRemaining;

  // Only show if 7 days or less remaining
  if (daysRemaining === null || daysRemaining > 7) return null;

  // Determine urgency level
  const isUrgent = daysRemaining <= 3;
  const isExpired = daysRemaining <= 0;

  const bgColor = isExpired
    ? 'bg-red-600'
    : isUrgent
    ? 'bg-yellow-500'
    : 'bg-blue-600';

  const textColor = isUrgent && !isExpired ? 'text-gray-900' : 'text-white';

  const message = isExpired
    ? 'Ihre Testphase ist abgelaufen!'
    : daysRemaining === 1
    ? 'Nur noch 1 Tag in der Testphase!'
    : `Noch ${daysRemaining} Tage in der Testphase`;

  return (
    <div className={`${bgColor} ${textColor}`}>
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <Clock className="w-4 h-4 flex-shrink-0" />
            <span className="text-sm font-medium truncate">{message}</span>
          </div>

          <div className="flex items-center gap-2">
            <Link
              to="/einstellungen/abonnement"
              className={`inline-flex items-center gap-1 px-3 py-1 text-sm font-medium rounded-md transition-colors ${
                isUrgent && !isExpired
                  ? 'bg-gray-900 text-white hover:bg-gray-800'
                  : 'bg-white/20 hover:bg-white/30'
              }`}
            >
              Jetzt upgraden
              <ArrowRight className="w-3 h-3" />
            </Link>

            {!isExpired && (
              <button
                onClick={() => setDismissed(true)}
                className="p-1 hover:bg-white/20 rounded-md transition-colors"
                aria-label="Banner schließen"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrialBanner;
